export const distanceConverter = (value: number, isMiles = false) => {
  if (isMiles && value) {
    return +value * 1000 * 1.609;
  }
  return +value * 1000;
};
